define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/util",
	"csi/xml"
], function(def, Action, ActionFactory, reflection, util, xml) {

	return ActionFactory.declare("Delete", Action, {
		// Boolean: force decision to delete over logic to automatically detect remove vs. delete
		bForce: null,

		// Boolean: indicates if Delete action actually only removes reference from parent to child node
		bRemove: null,

		constructor: function(obj) {
			// "Force" indicates to delete node even if not displaying composite relationship
			var f = util.getProperty(obj, "Force");
			if (f == "0") {
				this.bRemove = true;
			} else if (f == "1") {
				this.bForce = true;
			}

			this.m_tag = this.m_tag || "Delete";

			if (!this.m_typeControl) {
				this.setMaterialIcon('close');
				this.m_class = "csi-icon-delete " + (this.m_class || "");
			}

			// set appropriate rights for action - need to be careful because should be able to delete node even if read-only
			this.setBaseRights(null, xml.RIGHT_WRITE);
		},

		resolve: function(/*LocaleResolver*/lr, /*Class*/rcRoot, /*Node*/nodeRoot) {
			// summary: detect if delete action is really just used to remove reference to item;
			// this logic does not currently support paths
			var r = this.m_relationship;

			if ((this.bRemove === null) && !this.bForce && !this.m_path && r && r.m_id) {
				var rcr = r.m_rcSource?.getRelation(r.m_id, true, true);
				if (rcr) {
					if (rcr.isComposite) {
						this.bRemove = false;
					} else {
						this.bRemove = true;
					}
				}
			}

			if (this.bRemove) {
				this.m_id = this.m_id || "Remove";
				this.setMaterialIcon('remove_circle_outline');

				if (this.m_class) {
					this.m_class = this.m_class.replace(/csi\-icon\-delete/, "");
				}
			} else {
				// optimize action by not returning all modified nodes from publish
				this.setReturnParameters();
			}

			this.inherited(arguments);
		},

		hasAccess: function(/*Context*/ctx) {
			// summary: check that action has access in context
			var node = ctx.getNode();
			if (!node || !this.inherited(arguments)) return false;

			// if it is known that action is only remove node from its parent, then nothing more to check
			if (this.bRemove) return true;

			// if node cannot be deleted, then return false
			if (!xml.nodeCanBeDeleted(node)) return false;

			// if deleting node in context of real parent or forced delete, then done with checks
			if (this.bForce || (this.bRemove === false)) return true;

			// if node has no composite parent, then all done with checks
			var urlParent = node.__Parent__;
			if (!xml.isValidURL(urlParent)) return true;

			// otherwise, determine if node can be deleted from owner; if owner is not in cache, then don't delete
			var nodeParent = ctx.cache.getNode(urlParent);
			if (!nodeParent) return false;

			var rcr = reflection.getRelationBetweenNodes(node, nodeParent, true);
			return rcr ? xml.nodeHasAccess(nodeParent, xml.RIGHT_WRITE, rcr.getId()) : false;
		}
	});
});